(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/context/prolong-context.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/context/prolong-context.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  createContext = _React.createContext;
const getAllItsIds = svs.numbergames.productMapping.getAllItsIds;
const checkSavedWagerInfo = svs.numbergames.prolong_game.common.utils.checkSavedWagerInfo;
const _svs$numbergames$prol = svs.numbergames.prolong_game.hooks,
  useAccountBalance = _svs$numbergames$prol.useAccountBalance,
  usePrice = _svs$numbergames$prol.usePrice;
const ProlongContext = createContext();
const ProlongProvider = _ref => {
  var _wager$properties, _svs$utils$paramHandl, _ref2, _preparedProlongWager, _wager$wager, _preparedProlongWager2;
  let children = _ref.children,
    wager = _ref.wager,
    _ref$trackingCategory = _ref.trackingCategory,
    trackingCategory = _ref$trackingCategory === void 0 ? 'Prolong Game' : _ref$trackingCategory,
    onSuccessCb = _ref.onSuccessCb,
    onDoneCb = _ref.onDoneCb,
    onCancelCb = _ref.onCancelCb,
    getAfterChangeReturnUrl = _ref.getAfterChangeReturnUrl;
  const wagerId = wager.wagerId,
    totalDrawCount = wager.totalDrawCount,
    productName = wager.productName,
    isSyndicate = wager.isSyndicate;
  const syndicateId = (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.syndicateId;
  const _useState = useState((_svs$utils$paramHandl = svs.utils.paramHandler.get({
      key: 'afterpay'
    })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value),
    _useState2 = _slicedToArray(_useState, 2),
    wasReturnedFromDeposit = _useState2[0],
    setWasReturnedFromDeposit = _useState2[1];
  const _useState3 = useState(checkSavedWagerInfo(wagerId)),
    _useState4 = _slicedToArray(_useState3, 2),
    preparedProlongWager = _useState4[0],
    setPreparedProlongWager = _useState4[1];
  const initialDrawCount = (_ref2 = (_preparedProlongWager = preparedProlongWager === null || preparedProlongWager === void 0 ? void 0 : preparedProlongWager.drawCount) !== null && _preparedProlongWager !== void 0 ? _preparedProlongWager : (_wager$wager = wager.wager) === null || _wager$wager === void 0 || (_wager$wager = _wager$wager.bets[0]) === null || _wager$wager === void 0 ? void 0 : _wager$wager.originalNumDraws) !== null && _ref2 !== void 0 ? _ref2 : totalDrawCount.toString();
  const _useState5 = useState(initialDrawCount),
    _useState6 = _slicedToArray(_useState5, 2),
    drawCount = _useState6[0],
    setDrawCount = _useState6[1];
  const _useState7 = useState((_preparedProlongWager2 = preparedProlongWager === null || preparedProlongWager === void 0 ? void 0 : preparedProlongWager.selectedDays) !== null && _preparedProlongWager2 !== void 0 ? _preparedProlongWager2 : getAllItsIds(productName)),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedDays = _useState8[0],
    setSelectedDays = _useState8[1];
  const price = usePrice(drawCount, selectedDays, wager);
  const _useAccountBalance = useAccountBalance(syndicateId, isSyndicate),
    accountBalance = _useAccountBalance.accountBalance,
    isInitialised = _useAccountBalance.isInitialised,
    accountIsSyndicate = _useAccountBalance.accountIsSyndicate;
  const onCancelCallback = args => {
    setPreparedProlongWager({});
    setWasReturnedFromDeposit(false);
    onCancelCb === null || onCancelCb === void 0 || onCancelCb(args);
  };
  const onSuccessCallback = args => {
    setPreparedProlongWager({});
    setWasReturnedFromDeposit(false);
    onSuccessCb === null || onSuccessCb === void 0 || onSuccessCb(args);
  };
  return React.createElement(ProlongContext.Provider, {
    value: {
      drawCount,
      setDrawCount,
      wager,
      selectedDays,
      setSelectedDays,
      price,
      accountBalance,
      accountIsSyndicate,
      preparedProlongWager,
      isInitialised,
      trackingCategory,
      onCancelCb: onCancelCallback,
      onSuccessCb: onSuccessCallback,
      onDoneCb,
      getAfterChangeReturnUrl,
      wasReturnedFromDeposit,
      shouldResumePayment: preparedProlongWager.isExisting && isInitialised && price > 0
    }
  }, children);
};
setGlobal('svs.numbergames.prolong_game.context', {
  ProlongContext,
  ProlongProvider
});

 })(window);